import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { DataTypes } from "../../../../constants";

import { Container, Fab, Grid } from "@mui/material";
import BreadcrumbBuilder from "../BreadcrumbBuilder";
import EditIcon from "@mui/icons-material/Edit";
import Fetching from "../../../Common/Fetching";
import ConfirmDialog from "../../../Common/Dialog/ConfirmDialog";
import MessageCard from "./MessageCard";
import MessageForm from "./MessageForm";

import rmsActions from "../../../../actions/rmsActions";
import {
    getInboxMessages,
    getRmsAppCode,
    isFetching,
} from "../../../../reducers";

function MessageList({
    isFetching,
    messages,
    getMessages,
    addMessage,
    deleteMessage,
    appCode,
}) {
    const [openDialog, setOpenDialog] = useState(null);
    const [selected, setSelected] = useState(null);

    useEffect(() => {
        getMessages("inbox", appCode);
    }, [getMessages, appCode]);

    return (
        <Container className="content">
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <BreadcrumbBuilder />
                </Grid>
                {isFetching && (
                    <Grid item md={12}>
                        <Fetching />
                    </Grid>
                )}
                {!!messages &&
                    Array.isArray(messages) &&
                    messages
                        .sort((a, b) => (a.createdAt >= b.createdAt ? 1 : -1))
                        .map((message) => (
                            <Grid item xs={12} key={message.id}>
                                <MessageCard
                                    message={message}
                                    onDelete={() => {
                                        setOpenDialog("delete");
                                        setSelected(message);
                                    }}
                                />
                            </Grid>
                        ))}
            </Grid>
            <Fab
                color="secondary"
                aria-label="add"
                className="fab"
                onClick={() => setOpenDialog("add")}
            >
                <EditIcon />
            </Fab>
            {openDialog === "delete" && !!selected && (
                <ConfirmDialog
                    open
                    title="Delete message"
                    content={`The following message will be deleted: ${selected.subject}`}
                    confirmButtonLabel="Delete"
                    onConfirm={() => deleteMessage(appCode, selected.id)}
                    onCancel={() => {
                        setOpenDialog(null);
                        setSelected(null);
                    }}
                    onClose={() => {
                        setOpenDialog(null);
                        setSelected(null);
                    }}
                />
            )}
            {openDialog === "add" && (
                <MessageForm
                    open
                    onSave={(params) => addMessage(appCode, params)}
                    onClose={() => setOpenDialog(null)}
                    appCode={appCode}
                />
            )}
        </Container>
    );
}

const mapStateToProps = (state) => ({
    isFetching: isFetching(state, DataTypes.MESSAGES),
    messages: getInboxMessages(state),
    appCode: getRmsAppCode(state),
});

export default connect(mapStateToProps, {
    getMessages: rmsActions.getMessages,
    addMessage: rmsActions.addMessage,
    deleteMessage: rmsActions.deleteMessage,
})(MessageList);
